import { DeviceInfo } from 'qunar-react-native';
/**
 * 格式化qrn版本号便于比较
 * 原有格式：v1.2.3-RC || v1.2.3
 * 格式化后：123
 * @param ver 版本号
 */
const parseQrnVer = (ver) => {
    if (typeof ver !== 'string') {
        return 0;
    }
    // 只保留数字来做版本比较
    const verNum = ver.split('-')[0].replace(/[^\d]/g, '');
    return parseInt(verNum, 10);
};
/**
 * 是否在某个qrn版本之上(包含该版本)
 * @param ver 需要判断的qrn版本号
 */
const overQrnVer = (ver) => {
    const { qrn_version } = DeviceInfo;
    if (typeof ver !== 'string' || typeof qrn_version !== 'string') {
        return false;
    }
    return parseQrnVer(qrn_version) >= parseQrnVer(ver);
};
/**
 * 后续有依赖在这里加
 * 比如下次依赖qrn v5.0.0
 * 添加overV2 v5.0.0
 */
export const overVer = {
    overV0: overQrnVer('v4.5.0'),
    overV1: overQrnVer('v4.5.3'),
    overV2: overQrnVer('v4.5.4'),
    overV3: overQrnVer('v4.5.4') // todo:Q手势浮层的依赖
};
